import { DropdownItem, Tooltip } from 'bold-ui'
import { useSession } from 'components/auth/useSession'
import { DropdownButton } from 'components/dropdown'
import {
  DEMANDA_REPRIMIDA_PATH,
  GARANTIA_ACESSO_PATH,
  GESTAO_FILAS_PATH,
} from 'components/layout/SideMenu/SideMenuItems'
import { useFlags } from 'config/useFlagsContext'
import { MouseEvent } from 'react'
import { useHistory } from 'react-router'
import { CypressProps } from 'types/cypress'
import { NIVEL_SUPERIOR } from 'types/NivelCbo'
import Permissions from 'types/Permissions'
import { grupoCboVisualizarProntuario } from 'view/cidadao/authorization/acessos'

import { CidadaoGarantiaAcesso } from './model-garantiaAcesso'

interface GarantiaAcessoTableDropdownMenuProps extends CypressProps {
  cidadao: CidadaoGarantiaAcesso
  garantiaAcessoId: ID
  cuidadoCompartilhadoId?: ID
}

export function GarantiaAcessoTableDropdownMenu(props: GarantiaAcessoTableDropdownMenuProps) {
  const { cidadao, garantiaAcessoId, cuidadoCompartilhadoId, dataTestId } = props
  const cidadaoHasProntuario = !!cidadao.prontuario
  const history = useHistory()
  const { checkAuthorization, hasCboAuth } = useSession()
  const { PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()

  const hasPermissaoVisualizarProntuario =
    checkAuthorization(Permissions.visualizarProntuario) && hasCboAuth(grupoCboVisualizarProntuario)
  const hasPermissaoVisualizarCidadao = checkAuthorization(
    Permissions.gestaoDeCadastrosIndividuais.visualizarCadastroIndividual
  )
  const hasPermissaoVisualizarDiscussao =
    hasCboAuth(NIVEL_SUPERIOR) && checkAuthorization(Permissions.cuidadoCompartilhado.visualizarDiscussao)
  const hasAnyPermission =
    hasPermissaoVisualizarProntuario || hasPermissaoVisualizarCidadao || hasPermissaoVisualizarDiscussao

  if (!hasAnyPermission) {
    return null
  }

  const handleClickVisualizarProntuario = () => {
    history.push(`/cidadao/${cidadao.id}/folha-rosto`)
  }

  const handleClickVisualizarCidadao = () => {
    history.push(`/cidadao/${cidadao.id}/informacoes`)
  }

  const handleClickEditar = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    const basePath = PILOTO_INTEGRACAO_REGULACAO_ENABLED ? DEMANDA_REPRIMIDA_PATH : GARANTIA_ACESSO_PATH
    history.push(`${basePath}/editar-cidadao/${garantiaAcessoId}`)
  }
  const handleClickVisualizarDiscussaoCaso = () => {
    history.push(`${GESTAO_FILAS_PATH}/cuidados-compartilhados/visualizar/${cuidadoCompartilhadoId}/discussao-caso`)
  }

  return (
    <DropdownButton stopPropagationOnAction data-testid={dataTestId}>
      {!cuidadoCompartilhadoId && !cidadao.faleceu && (
        <DropdownItem data-testid='DropdownItem.Editar' onClick={handleClickEditar}>
          Editar
        </DropdownItem>
      )}
      {hasPermissaoVisualizarDiscussao && cuidadoCompartilhadoId && (
        <DropdownItem data-testid='DropdownItem.VisualizarDiscussao' onClick={handleClickVisualizarDiscussaoCaso}>
          Visualizar discussão
        </DropdownItem>
      )}
      {hasPermissaoVisualizarProntuario && (
        <Tooltip text={!cidadaoHasProntuario && 'Cidadão não possui prontuário'}>
          <DropdownItem
            data-testid='DropdownItem.VisualizarProntuario'
            disabled={!cidadaoHasProntuario}
            onClick={handleClickVisualizarProntuario}
          >
            Visualizar prontuário
          </DropdownItem>
        </Tooltip>
      )}
      {hasPermissaoVisualizarCidadao && (
        <DropdownItem data-testid='DropdownItem.VisualizarCidadao' onClick={handleClickVisualizarCidadao}>
          Visualizar cidadão
        </DropdownItem>
      )}
    </DropdownButton>
  )
}
